import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import DealsAPI from '../../api/deals';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  meta: {
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
  },
  uiFlags: {
    isFetching: false,
    isFetchingMore: false,
    hasFetchError: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getDeals($state) {
    return $state.records;
  },
  getMeta($state) {
    return $state.meta;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async function getDeals({ commit }) {
    commit(types.SET_DEALS_UI_FLAG, { isFetching: true, hasFetchError: false });
    try {
      const response = await DealsAPI.get(1);
      commit(types.SET_DEALS, response.data.payload);
      commit(types.SET_DEALS_META, response.data.meta);
    } catch (error) {
      commit(types.SET_DEALS_UI_FLAG, { hasFetchError: true });
    } finally {
      commit(types.SET_DEALS_UI_FLAG, { isFetching: false });
    }
  },
  fetchNextPage: async function fetchNextPage({ commit, state: dealsState }) {
    const { currentPage, totalPages } = dealsState.meta;
    if (currentPage >= totalPages) return;

    commit(types.SET_DEALS_UI_FLAG, { isFetchingMore: true, hasFetchError: false });
    try {
      const response = await DealsAPI.get(currentPage + 1);
      commit(types.APPEND_DEALS, response.data.payload);
      commit(types.SET_DEALS_META, response.data.meta);
    } catch (error) {
      commit(types.SET_DEALS_UI_FLAG, { hasFetchError: true });
    } finally {
      commit(types.SET_DEALS_UI_FLAG, { isFetchingMore: false });
    }
  },
  create: async function createDeal({ commit }, dealObj) {
    commit(types.SET_DEALS_UI_FLAG, { isCreating: true });
    try {
      const response = await DealsAPI.create(dealObj);
      commit(types.ADD_DEAL, response.data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_DEALS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_DEALS_UI_FLAG, { isUpdating: true });
    try {
      const response = await DealsAPI.update(id, updateObj);
      commit(types.EDIT_DEAL, response.data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_DEALS_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_DEALS_UI_FLAG, { isDeleting: true });
    try {
      await DealsAPI.delete(id);
      commit(types.DELETE_DEAL, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_DEALS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_DEALS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_DEALS]: MutationHelpers.set,
  [types.APPEND_DEALS]($state, data) {
    $state.records = [...$state.records, ...data];
  },
  [types.SET_DEALS_META]($state, meta) {
    $state.meta = {
      currentPage: Number(meta.current_page),
      totalPages: meta.total_pages,
      totalCount: meta.total_count,
    };
  },
  [types.ADD_DEAL]: MutationHelpers.setSingleRecord,
  [types.EDIT_DEAL]: MutationHelpers.update,
  [types.DELETE_DEAL]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
